export default __webpack_public_path__ + "static/media/fernando.be7ebb22.png";